import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FaChevronDown as DownChevron } from "@react-icons/all-files/fa/FaChevronDown";
import { FaChevronUp as UpChevron } from "@react-icons/all-files/fa/FaChevronUp";
import { MdPersonOutline } from "@react-icons/all-files/md/MdPersonOutline";
import { MdPower } from "@react-icons/all-files/md/MdPower";
import InviteModal from "./inviteModal";
import SidebarLogo from "shared/components/base-components/SidebarLogo";

import { sendAPIRequest } from "shared/utils/requests";
import { Icon } from "../base-components";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserMenuOpen: false,
      isInviteModalActive: false,
    };
  }

  logout = async () => {
    await sendAPIRequest("/contractor_users/logout", "DELETE");
    location.href = "/";
  };

  myAccount = async (id) => {
    location.href = "/contractor_users/" + id + "/";
  };

  renderFullSidebar = () => {
    const { currentContractor } = this.props;
    const { isUserMenuOpen, isInviteModalActive } = this.state;

    return (
      <div className="flex-col sidebar-wrapper">
        <div className="sidebar-content">
          <div className="sidebar-user-menu-container">
            <div
              className="flex-row sidebar-user-menu-button"
              onClick={() =>
                this.setState(({ isUserMenuOpen }) => ({
                  isUserMenuOpen: !isUserMenuOpen,
                }))
              }
            >
              <div className="sidebar-user-menu-name-container">
                <Icon filename="logo-white-v-blue-circle" />
                <span className="sidebar-user-menu-name">
                  {`${
                    currentContractor.first_name[0].toUpperCase() +
                    currentContractor.first_name.substring(1)
                  } ${currentContractor.last_name[0].toUpperCase()}`}
                </span>
              </div>
              <span className="sidebar-user-menu-chevron">
                {isUserMenuOpen ? (
                  <UpChevron size={20} />
                ) : (
                  <DownChevron size={20} />
                )}
              </span>
            </div>

            {isUserMenuOpen && (
              <div className="sidebar-user-menu-dropdown">
                <div
                  className="flex-row sidebar-user-menu-option"
                  onClick={() => {
                    this.setState({ isUserMenuOpen: false });
                    this.myAccount(currentContractor.id);
                  }}
                >
                  <span className="sidebar-user-menu-option-icon">
                    <MdPersonOutline size={15} />
                  </span>
                  <span className="sidebar-user-menu-option-label">
                    My Account
                  </span>
                </div>
                {/*<div
                  className="flex-row sidebar-user-menu-option"
                  onClick={() => {
                    this.setState({ isInviteModalActive: true, isUserMenuOpen: false });
                  }}
                >
                  <span className="sidebar-user-menu-option-icon"><MdPersonAdd size={15} /></span>
                  <span className="sidebar-user-menu-option-label">Invite to QAWorld</span>
                </div>*/}
                <div
                  className="flex-row sidebar-user-menu-option"
                  onClick={() => {
                    this.setState({ isUserMenuOpen: false });
                    this.logout();
                  }}
                >
                  <span className="sidebar-user-menu-option-icon">
                    <MdPower size={15} />
                  </span>
                  <span className="sidebar-user-menu-option-label">
                    Log Out
                  </span>
                </div>
              </div>
            )}
          </div>

          {isInviteModalActive ? (
            <InviteModal
              hideInviteModal={() =>
                this.setState({ isInviteModalActive: false })
              }
            />
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  };

  renderCollapsedSidebar = () => {
    return (
      <div className="sidebar-wrapper">
        <div className="sidebar-container">
          <Link to={"/"}>
            <SidebarLogo isCollapsed={true} />
          </Link>
        </div>
      </div>
    );
  };

  render() {
    const { isCollapsed } = this.props;

    if (!isCollapsed) {
      return this.renderFullSidebar();
    } else {
      return this.renderCollapsedSidebar();
    }
  }
}

export default Sidebar;
